import { logException } from "@wss/error-tracking";

interface Params {
  email: string;
  itemNumber: string;
  recaptchaToken: string;
}

const request = async ({ email, itemNumber, recaptchaToken }: Params) => {
  try {
    const body = {
      itemNumber,
      emailAddress: email,
      isOutlet: itemNumber.includes("outlet"),
      reCaptchaToken: recaptchaToken,
    };

    const response = await fetch(
      "/product-promotion/send-product-price-discount-email",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include",
      }
    );

    return response.ok
      ? { success: true }
      : { success: false, message: "There was an error sending the request." };
  } catch (error) {
    logException(error, "info");
    return {
      success: false,
      message: "An unexpected error occurred. Please try again.",
    };
  }
};

export default request;
